import {Injectable} from '@angular/core';
import {Auth, signOut} from '@angular/fire/auth';
import {ConsumerSessionModel} from 'spotcharge-types';
import {FirebaseAuthentication, User} from '@capacitor-firebase/authentication';
import {Capacitor} from '@capacitor/core';
import {GuestSessionService} from './guest-session.service';
import {UserHttpService} from './user-http.service';
import {PushNotificationService} from './push-notification.service';
import {BaseOccpHttpService} from './base-occp-http.service';
import {DeleteConsumerMeResponse} from 'spotcharge-types';
import {firstValueFrom} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthHttpService {
  isWeb = Capacitor.getPlatform() === 'web';
  constructor(
    public auth: Auth,
    private guestSessionService: GuestSessionService,
    private userHttpService: UserHttpService,
    private pushNotificationService: PushNotificationService,
    private occpHttp: BaseOccpHttpService,
  ) {
  }

  async logout() {
    await this.pushNotificationService.unregisterCurrentToken();
    await this.guestSessionService.clearGuest();
    // Explicitly clear the persisted session here (setAuthUser no longer clears
    // it on a transient null), so guards correctly treat the user as logged out.
    await this.userHttpService.clearStoredSession();
    try {
      if (this.isWeb) {
        await signOut(this.auth);
      } else {
        await FirebaseAuthentication.signOut();
      }
    } catch (error) {
      console.error('Firebase signOut after local session clear', error);
    }
  }

  async deleteAccount(): Promise<DeleteConsumerMeResponse> {
    return firstValueFrom(this.occpHttp.delete<DeleteConsumerMeResponse>('api/consumer/me'));
  }

  async setUserData(user: User, _isPhoneNumberLogin = false): Promise<ConsumerSessionModel | null> {
    return this.userHttpService.ensureSession(user);
  }

}
